import {formatUrlForCachedFiles, triggerPrerenderEvent} from "@/global/modules/functions.js";

export function importFonts(stylesheet_id){ //Google fonts only
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = "https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Exile&family=Playfair+Display:ital,wght@0,400..900;1,400..900&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100..900;1,100..900&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap";
    link.id = stylesheet_id;

    let head = document.getElementsByTagName('head')[0];
    head.appendChild(link);
}

export function removeSortableObjectsFromContents(page_content){

    let containers = page_content.containers.map(object => ({ ...object }))

    for (let i = 0; i < containers.length; i++) {
        let current_container = containers[i];

        current_container.sortable_instance = {};
        let blocks = current_container.blocks.map(object => ({ ...object }))

        for (let j = 0; j < blocks.length; j++) {
            let current_block = blocks[j];
            current_block.sortable_instance = {};
        }

        current_container.blocks = blocks;
    }

    return containers;
}


export async function importJavaScript(route, file_name = 'main.min.js'){
    try{
        /* Import compiled cached version of JS */
        // let js_id = `js_${route}`;
    
        // let dynamic_js = document.getElementById(js_id);
            
        // if(dynamic_js != null){
        //     dynamic_js.parentNode.removeChild(dynamic_js);
        // }
    
        // const res = await fetch(`/dynamic_pages/build_numbers/${route}_build.json`);
        // if (!res.ok) throw new Error('Route not found');
        // const build_number = await res.json();

        // const build_number = await import(`/public/dynamic_pages/build_numbers/${route}_build.json`);
    
        // let script = document.createElement('script')
        // script.setAttribute('src',`/dynamic_pages/js/${route}/${build_number.b}_${file_name}`);
        // script.defer = true;
        // script.id = js_id;
    
        // let head = document.getElementsByTagName('head')[0];
        // head.appendChild(script);
    }
    catch(e){

    }
}

export function importJavascriptFromBlob(js, id = 'pagebuilder_main_js'){
    /* Import un-minified, un-cached javascript directly from JSON - use on pagebuilder only */
    // let page_builder_js = document.getElementById(id);
        
    // if(page_builder_js != null){
    //     page_builder_js.remove();
    // }
    
    // let blob = new Blob([js], {type: 'text/javascript'});
    
    // let script = document.createElement('script');
    // script.setAttribute('src',`${window.URL.createObjectURL(blob)}`);
    // script.defer = true;
    // script.id = id;
    
    // let head = document.getElementsByTagName('head')[0];
    // head.appendChild(script);

}

export async function importCss(route){
    try{
        let css_id = `css_${route}`;
    
        let dynamic_css = document.getElementById(css_id);
            
        if(dynamic_css != null){
            dynamic_css.parentNode.removeChild(dynamic_css);
        }
    
        let link = document.createElement('link')
        link.rel = 'stylesheet';
    
        // const build_number = await import(`/public/dynamic_pages/build_numbers/${route}_build.json`);

        const res = await fetch(`/dynamic_pages/build_numbers/${route}_build.json`);
        if (!res.ok) throw new Error('Route not found');
        const build_number = await res.json();
        
    
        link.setAttribute('href',`/dynamic_pages/css/${route}/${build_number.b}_main.min.css`);
        link.id = css_id;
        link.media = "none"; //Setting to none then back to all will force css to be loaded async
        link.onload= () => { link.media = 'all'; link.rel='stylesheet';};
    
        let head = document.getElementsByTagName('head')[0];
        head.appendChild(link);
    }
    catch(e){

    }
}

export async function loadDynamicContent(url, content_type = ''){
    try{
        url = formatUrlForCachedFiles(url);
        url += content_type;
    
        if(url == '/' || url == ''){
            url = 'home';
        }

        importCss(url);
        // importJavaScript(url); //Put back in once re-enable JS
        const res = await fetch(`/dynamic_pages/content/${url}.json`);
        if (!res.ok) throw new Error('Route not found');
        const content = await res.json();

        // const content = await import(`/public/dynamic_pages/content/${url}.json`);
        loadFonts(content);
        triggerPrerenderEvent();
        return content;
    }
    catch(e){
        return {
            'page': null
        };
    }
}

function loadFonts(content){
    for (let i = 0; i < content.page.fonts.files.length; i++) {
        new FontFace(content.page.fonts.files[i].name, `url(/fonts/${content.page.fonts.files[i].font_file}`).load().then((font) => {
            document.fonts.add(font);
        });
    }
}

export async function importJavascriptFromString(js){ //NOT USING
    let moduleData = await import(/* webpackIgnore: true */ "data:text/javascript,export default ()=>{"+js+"}");

    return moduleData;
}


export function compileStylesToCss(object, id){ //FOR FUTURE USE

    let css = '';

    let styles_string = '';

    Object.keys(object).forEach((key) => {
        const css_property = object[key].css_property;
        const css_value = object[key].value;
        if(css_value != ''){
            styles_string += `${css_property}:${css_value};`;
        }

    });

    css = `#${id}{${styles_string}}`
}